import { API_URL, apiErrorResponse, apiSuccessResponse } from '@/shared/api/constants'
import { clearSessionCache, getCachedSession } from '@/shared/api/client-api/client-api'
import { GetHypothesisRelatedParams } from '@/shared/api/end-points/hypothesis'
import { ApiResponse } from '@/shared/api/types'

const getResearch = async (params: GetHypothesisRelatedParams): Promise<ApiResponse<null>> => {
  try {
    const session = await getCachedSession()
    const token = session?.user?.token

    if (!API_URL) {
      throw new Error('Provide API_URL')
    }

    const response = await fetch(`${API_URL}/api/v2.5/projects/${params.projectId}/hypotheses/${params.hypothesisId}/research/`, {
      cache: 'no-cache',
      headers: {
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
      },
    })

    const json = await response.json()

    if (!response.ok) {
      if (response.status === 401) {
        clearSessionCache()
      }

      throw new Error(json?.message || `Ошибка сервера: ${response.status} ${response.statusText}`)
    }

    if (json?.status === 'success') {
      return apiSuccessResponse({
        status: response.status,
        result: json?.data ?? null,
        response,
      })
    }

    if (json?.status === 'pending') {
      return apiSuccessResponse({
        status: response.status,
        result: json?.data ?? null,
        response,
        pending: true,
      })
    }

    throw new Error(json?.message || 'Произошла ошибка при обращении к серверу')
  } catch (error) {
    return apiErrorResponse({
      error,
    })
  }
}

export default getResearch
